export const InitialTime = () => {

  return {
      type: "InitialTime",
  }
};



// WEBPACK FOOTER //
// ./src/actions/initial-time.js